import ApiService from '@/services/api';
import { Entity, EntityBuilder } from '@decahedron/entity';
import Property from '@/entities/Property';
import Model from '@/entities/Model';
import CarOption from '@/entities/CarOption';
import CarDamage from '@/entities/CarDamage';

let instance: PropertyService = null;

export default class PropertyService {
    apiService: ApiService = null;

    constructor() {
        if (!instance) {
            this.apiService = new ApiService();
            instance = this;
        }

        return instance;
    }

    list(propertyType: string) {
        return this.apiService
            .get(propertyType)
            .then((response) => this.build(propertyType, response, true));
    }

    build(propertyType: string, response: any, many = false) {
        if (propertyType === 'models') {
            return many
                ? EntityBuilder.buildMany<Model>(Model, response.data)
                : EntityBuilder.buildOne(Model, response.data);
        }

        if (propertyType === 'options') {
            return many
                ? EntityBuilder.buildMany<CarOption>(CarOption, response.data)
                : EntityBuilder.buildOne(CarOption, response.data);
        }

        if (propertyType === 'damages') {
            return many
                ? EntityBuilder.buildMany<CarDamage>(CarDamage, response.data)
                : EntityBuilder.buildOne(CarDamage, response.data);
        }

        return many
            ? EntityBuilder.buildMany<Property>(Property, response.data)
            : EntityBuilder.buildOne(Property, response.data);
    }

    save(propertyType: string, property: any) {
        if (property.id) {
            return this.apiService
                .put(`${propertyType}/${property.id}`, property.toJson())
                .then((response) => this.build(propertyType, response));
        }

        return this.apiService
            .post(propertyType, property.toJson())
            .then((response) => this.build(propertyType, response));
    }

    delete(propertyType: string, property: any) {
        return this.apiService.delete(`${propertyType}/${property.id}`);
    }
}
